import { Button, Input } from '@artosera/ui';
import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useContacts } from '../../api/contacts.js';
import { useShellContext } from '../shell/context.js';
import { Field } from '../Field.js';
export function ChoixContact({
  valeur,
  onChange,
}: {
  valeur: { id: string; nom: string } | null;
  onChange: (c: { id: string; nom: string } | null) => void;
}) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation(['regie', 'commun']);
  const id = useId();
  const [recherche, setRecherche] = useState('');
  const contacts = useContacts(
    galerieSlug,
    { q: recherche, parPage: 20 },
    { enabled: recherche.trim().length >= 2 },
  );
  if (valeur)
    return (
      <div>
        <p>{valeur.nom}</p>
        <Button variant="ghost" onClick={() => onChange(null)}>
          {t('regie:pipeline.changerContact')}
        </Button>
      </div>
    );
  return (
    <div>
      <Field htmlFor={id} label={t('regie:pipeline.contact')}>
        <Input
          id={id}
          type="search"
          value={recherche}
          onChange={(e) => setRecherche(e.target.value)}
        />
      </Field>
      {contacts.data?.contacts
        .filter((c) => !c.archive && !c.anonymise)
        .map((c) => (
          <Button
            key={c.id}
            variant="ghost"
            onClick={() => onChange({ id: c.id, nom: c.nomAffiche })}
          >
            {c.nomAffiche}
          </Button>
        ))}
      {contacts.isError ? <p role="alert">{t('commun:erreurReseau')}</p> : null}
    </div>
  );
}
